import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { toast } from 'react-toastify';
import BtnFilled from '../../../components/BtnFilled';
import { getErrorDetails } from '../../../api/utils/parseErrors';
import { cn } from '../../../utils/cn';
import { formatLeakAlarmTime } from './formatLeakAlarmTime';
import { useLeakAlarm } from './useLeakAlarm';

const LeakAlarmStatus = ({ deviceId, timeZone, className, compact = false }) => {
  const { alarm, loaded, acking, ack } = useLeakAlarm(deviceId);

  const handleAck = async () => {
    try {
      await ack();
    } catch (err) {
      getErrorDetails(err, ({ error }) => toast.error(error, { hideProgressBar: true }));
    }
  };

  if (!loaded) return null;

  if (!alarm) {
    return <p className={cn('text-gray-800', className)}>Норма</p>;
  }

  const startedAt = formatLeakAlarmTime(alarm.started_at, timeZone);
  const mutedUntil = formatLeakAlarmTime(alarm.muted_until, timeZone);
  const isAcked = Boolean(alarm.acked_at);

  return (
    <div
      className={cn(
        'min-w-0 w-full rounded-2xl bg-red-50',
        compact ? 'px-2.5 py-2' : 'px-3 py-3',
        compact
          ? 'flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3'
          : 'flex flex-col items-center gap-2 text-center',
        !isAcked ? 'bg-red-50' : 'bg-red-50/70',
        className
      )}>
      <div
        className={cn(
          'flex min-w-0 items-start gap-1.5',
          compact ? 'flex-1' : 'w-full items-center justify-center'
        )}>
        <WarningAmberRoundedIcon className="mt-0.5 shrink-0 text-red-500" fontSize="small" />
        <div className={cn('min-w-0', !compact && 'text-center')}>
          <p className="font-semibold leading-snug text-red-600">Протечка с {startedAt}</p>
          {isAcked && mutedUntil && (
            <p className="mt-0.5 text-xs leading-snug text-gray-600 sm:text-sm">
              Вы оповещены, напоминания отключены до {mutedUntil}
            </p>
          )}
        </div>
      </div>

      <BtnFilled
        title="Оповещен"
        btnCb={handleAck}
        disabled={acking}
        className={cn(
          'shrink-0 bg-red-600 py-1.5 text-sm hover:bg-red-700',
          compact ? 'w-full sm:w-auto sm:min-w-[128px]' : 'w-full max-w-[160px]'
        )}
      />
    </div>
  );
};

export default LeakAlarmStatus;
